import {
  Container,
  FilterContainer,
  FilterSection,
  MineRsvCheckbox,
  TabBar,
  TabItem,
  UpperSection,
} from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { useState } from "react";
import DateFilter from "./date-filter";
import MyScheduledRsv from "./my-scheduled-rsv";
import MyHistoryRsv from "./my-rsv-history";

const MyBooking = () => {
  const [section, setSection] = useState<"예정된 예약/참석" | "지난 예약/참석">("예정된 예약/참석");

  const getAdjustedDate = (unit: string, n: number): Date => {
    const date = new Date();
    if (unit === "m") {
      date.setMonth(date.getMonth() + n);
    } else {
      date.setDate(date.getDate() + n);
    }
    return date;
  };

  const [upcomingStartDate, setUpcomingStartDate] = useState<Date>(new Date());
  const [upcomingEndDate, setUpcomingEndDate] = useState<Date>(() => getAdjustedDate("m", 1));
  const [pastStartDate, setPastStartDate] = useState<Date>(() => getAdjustedDate("m", -1));
  const [pastEndDate, setPastEndDate] = useState<Date>(getAdjustedDate("d", 0));

  const [creatorOnly, setCreatorOnly] = useState<boolean>(false);

  return (
    <Container
      style={{
        minWidth: 1060,
        boxSizing: "border-box",
      }}
    >
      <div className="top-section">
        <UpperSection>
          <UI.Typography
            type="title03"
            fontStyle="bold"
            color="var(--alias-color-label-neutral)"
            style={{
              padding: "24px 20px",
            }}
          >
            나의 예약/참석
          </UI.Typography>
          <div className="tab-container">
            <TabBar>
              <TabItem selected={section === "예정된 예약/참석"} onClick={() => setSection("예정된 예약/참석")}>
                <UI.Typography
                  type="body01 normal"
                  fontStyle="bold"
                  color={
                    section === "예정된 예약/참석"
                      ? "var(--alias-color-primary-normal)"
                      : "var(--alias-color-label-alternative)"
                  }
                >
                  예정된 예약/참석
                </UI.Typography>
              </TabItem>
              <TabItem selected={section === "지난 예약/참석"} onClick={() => setSection("지난 예약/참석")}>
                <UI.Typography
                  type="body01 normal"
                  fontStyle="bold"
                  color={
                    section === "지난 예약/참석"
                      ? "var(--alias-color-primary-normal)"
                      : "var(--alias-color-label-alternative)"
                  }
                >
                  지난 예약/참석
                </UI.Typography>
              </TabItem>
            </TabBar>
          </div>
        </UpperSection>
        <FilterSection>
          <FilterContainer>
            {section === "예정된 예약/참석" ? (
              <DateFilter
                startDate={upcomingStartDate}
                endDate={upcomingEndDate}
                onChange={(startDate, endDate) => {
                  setUpcomingStartDate(startDate);
                  setUpcomingEndDate(endDate);
                }}
                minDate={new Date()}
                maxDurationInMonths={6}
              />
            ) : (
              <></>
            )}
            {section === "지난 예약/참석" ? (
              <DateFilter
                startDate={pastStartDate}
                endDate={pastEndDate}
                onChange={(startDate, endDate) => {
                  setPastStartDate(startDate);
                  setPastEndDate(endDate);
                }}
                maxDate={getAdjustedDate("d", 0)}
                maxDurationInMonths={6}
              />
            ) : (
              <></>
            )}
            <MineRsvCheckbox>
              <UI.CheckBox selected={creatorOnly} onChange={setCreatorOnly} />
              <div
                onClick={() => {
                  setCreatorOnly(!creatorOnly);
                }}
                style={{ cursor: "pointer" }}
              >
                <UI.Typography type="body01 normal" fontStyle="medium">
                  나의 예약만 보기
                </UI.Typography>
              </div>
            </MineRsvCheckbox>
          </FilterContainer>
          <UI.Typography
            style={{ padding: "0 20px" }}
            type="label01"
            fontStyle="medium"
            color="var(--alias-color-label-alternative)"
          >
            * 최대 조회 가능 기간은 6개월입니다
          </UI.Typography>
        </FilterSection>
      </div>
      {section === "예정된 예약/참석" ? (
        <MyScheduledRsv startDate={upcomingStartDate} endDate={upcomingEndDate} creatorOnly={creatorOnly} />
      ) : (
        <MyHistoryRsv startDate={pastStartDate} endDate={pastEndDate} creatorOnly={creatorOnly} />
      )}
    </Container>
  );
};

export default MyBooking;
